<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <div class="table-agile-info">
          <el-tabs v-model="searchData.status_key">
            <el-tab-pane label="赴日统计" name="is_gone_japan"></el-tab-pane>
            <el-tab-pane label="缴费统计" name="is_pay_study"></el-tab-pane>
            <el-tab-pane label="赴日意向" name="purpose_level"></el-tab-pane>
            <el-tab-pane label="签证办理状态" name="sign_status"></el-tab-pane>
          </el-tabs>
          <el-row class="searchList" :gutter="10">
            <el-col :span="8">
              入学时间：
              <el-select
                class="jm-input135"
                v-model="searchData.year">
                <el-option
                  v-for="(option) in constDict.year"
                  :key="option"
                  :label="option"
                  :value="option"/>
              </el-select>
            </el-col>
          </el-row>

          <jm-tableList
            v-if="searchData"
            url="/index/b_i_j_p_writer/fetchStatus"
            :refresh="refresh"
            :search-data="searchData"
            :no-pagination="true"/>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import jmTableList from '@/components/data/tableList';
import common from '@/pages/bi/common';
import { jmChannel } from '@/components/tool';

let constDict = {
  year: ['全部']
};

export default {
  mixins: [common],
  data() {
    return {
      constDict,
      chartsData: {
        refresh: 1
      },
      chartsSort: {
        options: [],
        value: '资源数'
      },
      refresh: false,
      searchData: {
        status_key: 'is_gone_japan',
        year: (new Date()).getFullYear(),
      }
    };
  },
  components: {
    jmChannel, jmTableList
  },
  created() {
    this.$http
      ._get({
        url: '/index/b_i_j_p_writer/searchDict'
      })
      .then(({ data }) => {
        this.constDict = Object.assign({}, this.constDict, data);
        console.log('constDict', this.constDict);
        this.$store.commit('updateRefresh', true);
      });
  },
  methods: {
    init() {
      this.$store.commit('updateRefresh', true);
    }
  },
  watch: {
    searchData: {
      handler: function () {
        this.$nextTick(this.init);
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.searchList *{
  padding: 5px;
}
</style>
